export const getSelectedColumns = (columnsList: any) => {
  return columnsList.filter(
    (column: any) => column.isChecked || !Object.prototype.hasOwnProperty.call(column, 'isChecked')
  );
};
